import { render, staticRenderFns } from "./AjoutClient.vue?vue&type=template&id=315acb4f&scoped=true"
import script from "./AjoutClient.vue?vue&type=script&lang=js"
export * from "./AjoutClient.vue?vue&type=script&lang=js"
import style0 from "./AjoutClient.vue?vue&type=style&index=0&id=315acb4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315acb4f",
  null
  
)

export default component.exports